import variableColors from "@/base/global/variables/figma.colors.json";
import variableEffects from "@/base/global/variables/figma.effects.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const globalThemeTokens: any = {
  colorInfo: variableColors["ColorFigmaComplementaryBlue50"],
  colorTextBase: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorBgBase: variableColors["ColorFigmaNeutralWhiteWhite100"],
  borderRadius: 4,
  boxShadow: variableEffects["BoxShadowElevation3"],
  boxShadowSecondary: variableEffects["BoxShadowElevation3"],

  //================= success ====================/
  colorSuccessBg: variableColors["ColorFigmaFunctionalSuccess10"],
  colorSuccessBgHover: variableColors["ColorFigmaFunctionalSuccess10"],
  colorSuccessBorder: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSuccessBorderHover: variableColors["ColorFigmaFunctionalSuccess60"],
  colorSuccessHover: variableColors["ColorFigmaFunctionalSuccess60"],
  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSuccessActive: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSuccessTextHover: variableColors["ColorFigmaFunctionalSuccess60"],
  colorSuccessText: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSuccessTextActive: variableColors["ColorFigmaFunctionalSuccess60"],

  //================= error =====================/
  colorErrorBg: variableColors["ColorFigmaFunctionalAlert10"],
  colorErrorBgHover: variableColors["ColorFigmaFunctionalAlert10"],
  colorErrorBorder: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorBorderHover: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorHover: variableColors["ColorFigmaFunctionalAlert60"],
  colorError: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorActive: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorTextHover: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorText: variableColors["ColorFigmaFunctionalAlert50"],
  colorErrorTextActive: variableColors["ColorFigmaFunctionalAlert50"],

  //================= WARNING =====================/
  colorWarning: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningBg: variableColors["ColorFigmaFunctionalWarning10"],
  colorWarningBgHover: variableColors["ColorFigmaFunctionalWarning10"],
  colorWarningBorder: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningBorderHover: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningHover: variableColors["ColorFigmaFunctionalWarning60"],
  colorWarningActive: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningTextHover: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningText: variableColors["ColorFigmaFunctionalWarning50"],
  colorWarningTextActive: variableColors["ColorFigmaFunctionalWarning50"],

  //================= PRIMARY ======================/
  colorPrimaryBg: variableColors["ColorFigmaComplementaryBlue10"],
  colorPrimaryBgHover: variableColors["ColorFigmaComplementaryBlue10"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryBorderHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue60"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryActive: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryTextHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryText: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryTextActive: variableColors["ColorFigmaComplementaryBlue50"],

  //================= GLOBAl ======================/
  zIndexHeader: 10,
  heightHeader: "64px",

  maxWidthSection: "1312px",
  paddingXSInlineSection: "16px",
  paddingInlineSection: "32px",
  paddingBlockSection: "32px",

  //================= FIGMA ======================/
  ...variableColors,
  ...variableEffects,
  ...variableTypography,
};
